import type { EffectiveRole } from '@domain/entities';
import type { IAccessRepository } from '@domain/repositories';
import type { AssignRolePayload } from '@application/dto';
import type { IHttpClient } from '@application/ports';
import { API_ENDPOINTS } from '@infrastructure/config';

export class AccessRepository implements IAccessRepository {
  constructor(private readonly httpClient: IHttpClient) {}

  async rolesOfUser(userId: string): Promise<EffectiveRole[]> {
    const response = await this.httpClient.get<EffectiveRole[]>(
      API_ENDPOINTS.access.userRoles(userId)
    );
    return response.data;
  }

  async myRoles(): Promise<EffectiveRole[]> {
    const response = await this.httpClient.get<EffectiveRole[]>(API_ENDPOINTS.access.myRoles);
    return response.data;
  }

  async assign(userId: string, payload: AssignRolePayload): Promise<EffectiveRole[]> {
    const response = await this.httpClient.post<EffectiveRole[]>(
      API_ENDPOINTS.access.userRoles(userId),
      payload
    );
    return response.data;
  }

  async revoke(userId: string, roleId: string): Promise<EffectiveRole[]> {
    const response = await this.httpClient.delete<EffectiveRole[]>(
      API_ENDPOINTS.access.userRole(userId, roleId)
    );
    return response.data;
  }
}
